"use client";

import React from "react";
import { Coffee, Leaf, ShoppingBag } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseAreas = [{
  title: "The Coffee Bar",
  description: "Expertly pulled espresso shots, velvety lattes, and our signature house blends. We source premium beans to ensure every cup at M&M Café is a moment of pure warmth and artisanal quality.",
  icon: Coffee
}, {
  title: "The Matcha Bar",
  description: "Experience the art of ceremonial grade matcha. From traditional whisks to seasonal blends and iced lattes, our matcha is selected for its vibrant color and smooth, earthy profile.",
  icon: Leaf
}, {
  title: "European Market",
  description: "Browse our curated selection of imported European grocery items. From specialty chocolates to authentic pantry staples, we bring the flavors of the continent to Enfield.",
  icon: ShoppingBag
}];
export default function TheCoffeeMatchaBar() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222090" id="the-coffee-matcha-bar" className="bg-background py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-50"></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-secondary/10 rounded-lg blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-6 md:px-8 max-w-7xl relative z-10">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <h2 className="text-sm font-semibold tracking-[0.2em] text-ring uppercase mb-4 font-sans">
            Artisanal Offerings
          </h2>
          <h3 className="text-4xl md:text-6xl font-bold font-default text-foreground leading-tight">
            Our Specialties
          </h3>
          <p className="mt-6 text-lg text-muted-foreground font-sans leading-relaxed">
            A warm, modern neighborhood destination in Enfield, CT. Whether you're here for a morning espresso, a ceremonial matcha, or to explore our European grocery, we welcome you.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {expertiseAreas.map((area, i) => <Card key={i} data-index={i} className={`group p-10 bg-card border border-border/60 hover:border-secondary/40 shadow-sm hover:shadow-xl transition-all duration-500 ease-out flex flex-col h-full transform rounded-lg ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <CardHeader className="p-0 mb-8">
                <div className="w-16 h-16 rounded-lg bg-accent/50 flex items-center justify-center mb-8 border border-accent transition-colors duration-300 group-hover:bg-secondary/10 group-hover:border-secondary/20">
                  <area.icon className="w-8 h-8 text-secondary transition-transform duration-500 group-hover:scale-110" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-2xl md:text-3xl font-bold font-default text-foreground group-hover:text-secondary transition-colors duration-300">
                  {area.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-0 flex-grow">
                <p className="text-muted-foreground font-sans leading-relaxed text-base">
                  {area.description}
                </p>
              </CardContent>
              
              {}
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-secondary transition-all duration-500 ease-out group-hover:w-full"></div>
            </Card>)}
        </div>
      </div>
    </section>;
}